import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorService, ForbiddenError } from 'src/app/service/error.service';
import { TranslationService } from 'src/app/service/translation.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    providers:[ TranslationService ],
    imports: [ TranslateModule ],
    standalone: true
})
export class ErrorComponent implements OnInit {

  public image:string = '/assets/images/Components/illustration_error_404.svg';
  public message: string = 'error-message-400';
  public info: string = 'error-info-400';

  public canBack: boolean = false;
  public canRefresh: boolean = false;

  translationService = inject(TranslationService);

  constructor(public router: Router) {
    if (ErrorService.error) {
      if (ErrorService.error instanceof HttpErrorResponse) {
        switch (ErrorService.error.status) {
          case 400:
          case 404:
            this.image = '/assets/images/Components/illustration_error_404.svg';
            this.message = 'error-message-400';
            this.info = 'error-info-400';
            this.canBack = true;
            break;
          case 403:
          case 401:
          case 405:
            this.image = '/assets/images/Components/illustration_error_403.svg';
            this.message = 'error-message-403';
            this.info = 'error-info-403';
            this.canBack = true;
            break;
          default:
            this.image = '/assets/images/Components/illustration_error_500.svg';
            this.message = 'error-message-500';
            this.info = 'error-info-500';
            this.canRefresh = true;
        }
      } else if (ErrorService.error instanceof ForbiddenError) {
        this.image = '/assets/images/Components/illustration_error_403.svg';
        this.message = 'error-message-403';
        this.info = 'error-info-403';
        this.canBack = true;
      }  else {
        this.image = '/assets/images/Components/illustration_error_404.svg';
        this.message = 'error-message-400';
        this.info = 'error-info-400';
        this.canBack = true;
      }
    } else {
      this.image = '/assets/images/Components/illustration_error_404.svg';
      this.message = 'error-message-400';
      this.info = 'error-info-400';
      this.canBack = true;
    }
  }

  public refresh(): void {
    location.reload();
  }

  public back(): void {
    globalThis.history.back();
  }

  public home(): void{
    this.router.navigate(['/'], { skipLocationChange: true });
  }
  
  ngOnInit(): void {
   
    this.translationService.get('error').subscribe((translation) => {
      document.title = `DIP - ${translation}`;
    });
  }

}
